class EconoSmartProductCards {
  constructor() {
    this.storageKey = 'econosmart:wishlist';
    this.bindEvents();
    this.refreshWishlist();
  }

  bindEvents() {
    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-card-swatch]');
      const wishlist = event.target.closest('[data-wishlist-toggle]');

      if (swatch) {
        event.preventDefault();
        this.selectSwatch(swatch);
      }

      if (wishlist) {
        event.preventDefault();
        this.toggleWishlist(wishlist);
      }
    });

    document.addEventListener('change', (event) => {
      const select = event.target.closest('[data-card-variant-select]');
      if (select) this.selectVariant(select);
    });

    document.addEventListener('shopify:section:load', () => this.refreshWishlist());
    document.addEventListener('econosmart:content-updated', () => this.refreshWishlist());
  }

  selectSwatch(button) {
    const card = button.closest('[data-product-card]');
    if (!card) return;

    card.querySelectorAll('[data-card-swatch]').forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-selected', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    this.updateCard(card, {
      variantId: button.dataset.variantId,
      url: button.dataset.url,
      price: button.dataset.price,
      comparePrice: button.dataset.comparePrice,
      image: button.dataset.image,
      discount: Number(button.dataset.discount || 0),
      available: button.dataset.available === 'true'
    });
  }

  selectVariant(select) {
    const card = select.closest('[data-product-card]');
    const option = select.options[select.selectedIndex];
    if (!card || !option) return;

    this.updateCard(card, {
      variantId: option.value,
      url: option.dataset.url,
      price: option.dataset.price,
      comparePrice: option.dataset.comparePrice,
      available: option.dataset.available === 'true'
    });
  }

  updateCard(card, variant) {
    if (variant.variantId) {
      card.querySelectorAll('[data-quick-add]').forEach((button) => {
        button.dataset.variantId = variant.variantId;
        button.disabled = variant.available === false;
        if (variant.available === false) button.textContent = 'Agotado';
        else if (button.textContent === 'Agotado') button.textContent = 'Agregar';
      });
    }

    if (variant.url) {
      card.querySelectorAll('[data-card-product-link]').forEach((link) => {
        link.href = variant.url;
      });
    }

    if (variant.price) {
      const price = card.querySelector('[data-card-current-price]');
      if (price) price.textContent = variant.price;
    }

    const compare = card.querySelector('[data-card-compare-price]');
    if (compare) {
      compare.textContent = variant.comparePrice || '';
      compare.classList.toggle('is-hidden', !variant.comparePrice);
    }

    if (variant.image) {
      const image = card.querySelector('.product-card__primary-image');
      if (image && image.src !== variant.image) {
        image.src = variant.image;
        image.removeAttribute('srcset');
      }
    }

    const saleBadge = card.querySelector('[data-card-sale-badge]');
    if (saleBadge && Number.isFinite(variant.discount)) {
      if (variant.discount > 0) {
        saleBadge.hidden = false;
        if (/^-\d+%$/.test(saleBadge.textContent.trim())) saleBadge.textContent = `-${variant.discount}%`;
      } else {
        saleBadge.hidden = true;
      }
    }
  }

  getWishlist() {
    try {
      const value = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
      return Array.isArray(value) ? value.map(String) : [];
    } catch (_) {
      return [];
    }
  }

  setWishlist(items) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(items));
    } catch (_) {}
  }

  toggleWishlist(button) {
    const productId = String(button.dataset.productId || '');
    if (!productId) return;

    const wishlist = this.getWishlist();
    const index = wishlist.indexOf(productId);

    if (index >= 0) wishlist.splice(index, 1);
    else wishlist.push(productId);

    this.setWishlist(wishlist);
    this.refreshWishlist();

    const card = button.closest('[data-product-card]');
    const title = card?.querySelector('.product-card__title')?.textContent?.trim() || 'Producto';
    const liveRegion = document.querySelector('[data-global-live-region]');
    if (liveRegion) liveRegion.textContent = index >= 0 ? `${title} se quitó de favoritos.` : `${title} se agregó a favoritos.`;
  }

  refreshWishlist() {
    const wishlist = this.getWishlist();

    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const active = wishlist.includes(String(button.dataset.productId || ''));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');

      const card = button.closest('[data-product-card]');
      const title = card?.querySelector('.product-card__title')?.textContent?.trim() || 'producto';
      button.setAttribute('aria-label', `${active ? 'Quitar' : 'Agregar'} ${title} ${active ? 'de' : 'a'} favoritos`);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new EconoSmartProductCards();
});
